export const SEO_DATA = {
  '/': {
    title: 'Fastline - Votre boutique en ligne gratuitement',
    description:
      'Créez votre boutique en ligne en quelques minutes avec Fastline. Ajoutez vos produits, acceptez les paiements et commencez à vendre immédiatement.',
  },

  '/blog': {
    title: 'Blog - Fastline',
    description:
      'Conseils, stratégies et actualités pour développer votre activité en ligne avec Fastline.',
  },

  '/login': {
    title: 'Connexion - Fastline',
    description:
      'Connectez-vous à votre espace Fastline pour gérer vos commandes et votre boutique.',
  },

  // 🔹 Pages légales

  '/legal-notice': {
    title: 'Mentions légales - Fastline',
    description:
      'Consultez les informations légales concernant l’éditeur et l’hébergement de la plateforme Fastline.',
  },

  '/terms-of-service': {
    title: 'Conditions d’utilisation - Fastline',
    description:
      'Consultez les conditions générales d’utilisation de la plateforme Fastline.',
  },

  '/terms-of-sale': {
    title: 'Conditions de vente - Fastline',
    description:
      'Consultez les conditions générales de vente applicables aux commandes réalisées via Fastline.',
  },

  '/privacy-policy': {
    title: 'Politique de confidentialité - Fastline',
    description:
      'Découvrez comment Fastline collecte, utilise et protège vos données personnelles.',
  },

  '/cookie-policy': {
    title: 'Politique de cookies - Fastline',
    description:
      'Informations sur l’utilisation des cookies et traceurs sur la plateforme Fastline.',
  },
};

export const DEFAULT_SEO = {
  title: 'Fastline - Votre boutique en ligne gratuitement',
  description:
    'Fastline vous permet de créer votre boutique en ligne, accepter les paiements et vendre facilement, sans complexité.',
    image: 'https://fastlineapp.com/og-image.jpg'
};